import VZprint from './print.js'
VZprint.install = function (Vue) {
  Vue.directive('vzprint', VZprint)
}

export default VZprint
